// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { categoryDetailSubCategoriesStyles } from "@conklin/Overrides/Widgets/Category/CategoryDetailSubCategories";
import { xScreen } from "@conklin/XDL/Utilities";
import { css } from "styled-components";

categoryDetailSubCategoriesStyles.wrapper = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        gap: 32px 22px;
        justify-content: center;

        ${xScreen("lte", "md")} {
            gap: 24px 49px;
        }
        ${xScreen("lte", "xs")} {
            gap: 24px 16px;
        }
    `,
};

categoryDetailSubCategoriesStyles.subCategoryItem = {
    width: [12, 12, 4, 4, 2],
    css: css`
        padding: 0;
    `,
};

categoryDetailSubCategoriesStyles.subCategoryImageItem = {
    width: [2, 2, 12, 12, 12],
    css: css`
        width: 100%;
    `,
};

categoryDetailSubCategoriesStyles.categoryItemStyles = {
    categoryItem: {
        css: css`
            max-width: 204px;
            justify-content: start;

            ${xScreen("lte", "md")} {
                max-width: 147px;
            }
            ${xScreen("lte", "xs")} {
                max-width: 156px;
            }
        `,
    },
    categoryTitle: {
        css: css`
            text-align: center;
        `,
    },
    image: {
        css: css`
            width: 204px;
            height: 204px;
            ${xScreen("lte", "md")} {
                width: 147px;
                height: 147px;
            }
            ${xScreen("lte", "xs")} {
                width: 156px;
                height: 156px;
            }
        `,
    },
};
